function resize_promo(){
  if(document.querySelectorAll('.snippet-promo-image.desk-promo')) document.querySelectorAll('.snippet-promo-image.desk-promo').forEach((promo) => {
    setTimeout(() => {
      let prev = promo.previousSibling;
      if(prev){
        if(prev.classList.contains('product-item')){
          promo.style.height = ((prev.clientHeight*2+32) - prev.querySelector('.grid-meta').clientHeight) +'px';
        }
      }
    }, 800);
  })
  document.querySelectorAll('.product-item').forEach((desk_grid) => {
      desk_grid.classList.remove('coll-grid-desk-space');
  });
  let grid = document.querySelector(".collection-grid");
  let products = Array.from(grid.querySelectorAll(".product-item"));
  let productsPerRow = parseInt(grid.getAttribute("data-desk"), 10) || 6;
  let visibleCount = 0;
  products.forEach((product) => {
      if (product.style.display !== "none") {
          visibleCount++;
          let productRect = product.getBoundingClientRect();
          if ((visibleCount - 1) % productsPerRow === 0 || productRect.left === 0) {
              product.classList.add("coll-grid-desk-space");
          }
      }
  });
  document.dispatchEvent(new 
  CustomEvent("swym:collections-loaded"));
  
  let images = document.querySelectorAll(".product-images img:not(.second-image)");
  images.forEach((img) => {
    if(img.complete){
      img.classList.add("loaded");
    }else{
      img.addEventListener("load", () => img.classList.add("loaded"));
    }
  });
  
}
function quick_buy_btn(){
  quickAddButton();
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.body.classList.add('open-quick-buy');
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
  resize_promo();
}
// function load_more(){
//   const loadMoreBtn = document.querySelector('.load-more');
//   let currentRowsLoaded = 2;
//   const desktopProductsPerRow = parseInt(document.querySelector('.collection-grid').getAttribute('data-desk'));
//   const mobileProductsPerRow = 2;
//   const rowsPerLoad = 2;
//   const desktopProductsPerLoad = rowsPerLoad * desktopProductsPerRow;
//   const mobileProductsPerLoad = rowsPerLoad * mobileProductsPerRow;
//   const desktopPromoImages = document.querySelectorAll('.snippet-promo-image.desk-promo');
//   const mobilePromoImages = document.querySelectorAll('.snippet-promo-image.mb-promo');
//   const isMobile = window.innerWidth < 992;
//   const getProductsPerRow = () => (isMobile ? mobileProductsPerRow : desktopProductsPerRow);
//   if(loadMoreBtn){
//     loadMoreBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       const nextPageUrl = loadMoreBtn.getAttribute('href');
//       if (!nextPageUrl) return;
//       if(document.querySelector('.coll-more-scroll')) document.querySelector('.coll-more-scroll').classList.add('loading');
//       fetch(nextPageUrl)
//         .then(response => response.text())
//         .then(html => {
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, 'text/html');
//           const newProducts = doc.querySelectorAll('.collection-grid .product-item');
//           const nextPaginationLink = doc.querySelector('.coll-more-scroll .load-more');
//           const productGrid = document.querySelector('#product-grid');
//           newProducts.forEach(product => productGrid.appendChild(product));
//           const displayPromoImages = (promoImages, rowAttribute) => {
//             promoImages.forEach(promo => {
//               const promoRow = parseInt(promo.getAttribute(rowAttribute), 10);
//               const productsPerRow = getProductsPerRow();
//               const productsLoaded = currentRowsLoaded * productsPerRow;
//               if(promoRow <= currentRowsLoaded + rowsPerLoad && promo.style.display === 'none'){
//                 promo.style.display = 'block';
//                 productGrid.appendChild(promo);
//               }
//             });
//           };
//           if(isMobile){
//             displayPromoImages(mobilePromoImages, 'data-mob-row');
//           }else{
//             displayPromoImages(desktopPromoImages, 'data-desk-row');
//           }
//           currentRowsLoaded += rowsPerLoad;
//           if(nextPaginationLink){
//             loadMoreBtn.setAttribute('href', nextPaginationLink.getAttribute('href'));
//           }else{
//             document.querySelector('.coll-more-scroll').remove();
//           }
//           if(document.querySelector('.coll-more-scroll')) document.querySelector('.coll-more-scroll').classList.remove('loading');
//           quick_buy_btn();
//         })
//         .catch(err => console.error('Error loading products:', err));
//     });
//   }
// }
if (window.innerWidth < 992) {
// Global variables for state management
let currentRowsLoaded = 2;
let isLoading = false;

/* ---------- Helpers ---------- */

// deterministic fallback hash
function stableHash(str) {
  if (!str) return '';
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h) + str.charCodeAt(i);
    h = h & h;
  }
  return 'h' + (h >>> 0).toString(36);
}

// safe find by data-attribute value (avoids needing CSS.escape)
function findByDataAttr(container, attrName, value) {
  if (!container) return null;
  const nodes = container.querySelectorAll(`[${attrName}]`);
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].getAttribute(attrName) === value) return nodes[i];
  }
  return null;
}

// get a stable product id (prefer server data-id, then product link href, then hash)
function getProductId(node) {
  if (!node) return '';
  const attr = node.getAttribute('data-id') || node.getAttribute('data-product-id');
  if (attr) return attr;
  const anchor = node.querySelector('a[href]');
  if (anchor) {
    // use path+pathname to be stable (strip query)
    try {
      const url = new URL(anchor.href, location.origin);
      return url.pathname;
    } catch (e) {
      return anchor.getAttribute('href');
    }
  }
  return stableHash(node.outerHTML);
}

// get a stable promo id (prefer data-promo-id, then img src, then hash)
function getPromoId(node) {
  if (!node) return '';
  const attr = node.getAttribute('data-promo-id');
  if (attr) return attr;
  const img = node.querySelector('img[src]');
  if (img) {
    try {
      const url = new URL(img.src, location.origin);
      return url.pathname;
    } catch (e) {
      return img.getAttribute('src');
    }
  }
  return stableHash(node.outerHTML);
}

/* normalize ids for existing DOM/restored HTML so fetched nodes won't duplicate them */
function normalizeExistingIds(productGrid) {
  if (!productGrid) return;
  productGrid.querySelectorAll('.product-item').forEach(item => {
    if (!item.getAttribute('data-id')) {
      const id = getProductId(item);
      item.setAttribute('data-id', id);
    }
  });

  productGrid.querySelectorAll('.snippet-promo-image').forEach(promo => {
    if (!promo.getAttribute('data-promo-id')) {
      const pid = getPromoId(promo);
      promo.setAttribute('data-promo-id', pid);
    }
    // mark already-visible promos as placed
    if (!promo.dataset.placed) {
      promo.dataset.placed = (promo.style.display && promo.style.display !== 'none') ? '1' : '0';
    }
  });
}

/* ---------- main load_more (keeps your structure) ---------- */

function load_more(){
  const loadMoreBtn = document.querySelector('.load-more');
  const desktopProductsPerRow = parseInt(document.querySelector('.collection-grid').getAttribute('data-desk')) || 4;
  const mobileProductsPerRow = 2;
  const rowsPerLoad = 6;
  const productGrid = document.querySelector('#product-grid');
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;

  // normalize what's already in DOM (important for restored HTML)
  normalizeExistingIds(productGrid);

  const hasProductWithId = (id) => !!findByDataAttr(productGrid, 'data-id', id);
  const hasPromoWithId = (id) => !!findByDataAttr(productGrid, 'data-promo-id', id);

  // compute products per row dynamically (handles resize mode changes)
  const getProductsPerRow = () => (window.innerWidth < 992 ? mobileProductsPerRow : desktopProductsPerRow);

  // Places promos that are ready to be inserted into rows <= currentRowsLoaded
  const displayPromoImages = (rowAttribute) => {
    // query current promos inside the productGrid (includes newly appended promos)
    const isMobileLocal = window.innerWidth < 992;
    const selector = isMobileLocal ? '.snippet-promo-image.mb-promo' : '.snippet-promo-image.desk-promo';
    const promoImages = productGrid.querySelectorAll(selector);
    const productsPerRow = getProductsPerRow();

    promoImages.forEach(promo => {
      if (promo.dataset.placed === '1') return; // already placed

      const promoRowRaw = promo.getAttribute(rowAttribute) || promo.getAttribute('data-mob-row') || promo.getAttribute('data-desk-row');
      const promoRow = parseInt(promoRowRaw, 10);
      if (isNaN(promoRow)) return;

      // only place promos for rows that are already loaded
      if (promoRow > currentRowsLoaded) return;

      const allProducts = productGrid.querySelectorAll('.product-item');
      const insertAfterIndex = promoRow * productsPerRow - 1;
      const targetProduct = allProducts[insertAfterIndex];

      if (targetProduct) {
        promo.style.display = 'block';
        targetProduct.insertAdjacentElement('afterend', promo);
        promo.dataset.placed = '1';
      }
    });
  };

  const loadNextPage = () => {
    if (!loadMoreBtn || isLoading) return;
    const nextPageUrl = loadMoreBtn.getAttribute('href');
    if (!nextPageUrl) return;

    isLoading = true;
    const collMoreEl = document.querySelector('.coll-more-scroll');
    if (collMoreEl) collMoreEl.classList.add('loading');

    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        // remove previous placeholders
        document.querySelectorAll('.blank-span').forEach(b => b.remove());

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Normalize existing DOM again - defensive
        normalizeExistingIds(productGrid);

        // Append unique products
        const newProducts = doc.querySelectorAll('.collection-grid .product-item');
        newProducts.forEach(product => {
          // ensure a stable id on the fetched node
          let pid = product.getAttribute('data-id') || product.getAttribute('data-product-id');
          if (!pid) {
            // prefer link href fallback
            const anchor = product.querySelector('a[href]');
            if (anchor) {
              try {
                const url = new URL(anchor.href, location.origin);
                pid = url.pathname;
              } catch (e) {
                pid = anchor.getAttribute('href');
              }
            } else {
              pid = stableHash(product.outerHTML);
            }
            product.setAttribute('data-id', pid);
          }

          if (!hasProductWithId(pid)) {
            productGrid.appendChild(product);
          }
        });

        // Append unique promos (hidden initially) - they'll be placed by displayPromoImages
        const newPromos = doc.querySelectorAll('.snippet-promo-image');
        newPromos.forEach(promo => {
          let promoId = promo.getAttribute('data-promo-id');
          if (!promoId) {
            const img = promo.querySelector('img[src]');
            if (img) {
              try {
                const url = new URL(img.src, location.origin);
                promoId = url.pathname;
              } catch (e) {
                promoId = img.getAttribute('src');
              }
            } else {
              promoId = stableHash(promo.outerHTML);
            }
            promo.setAttribute('data-promo-id', promoId);
          }

          if (!hasPromoWithId(promoId)) {
            promo.style.display = 'none';
            promo.dataset.placed = '0';
            productGrid.appendChild(promo);
          }
        });

        // Add placeholders (as your original)
        const parentElement = document.querySelector('.collection-grid');
        const limit = parseInt(parentElement.getAttribute('data-limit') || 0, 10);
        for (let i = 0; i < limit; i++) {
          const span = document.createElement('span');
          span.classList.add('blank-span');
          parentElement.appendChild(span);
        }

        // ------------ KEY FIX: increase rows BEFORE placing promos ------------
        currentRowsLoaded += rowsPerLoad;
        window.currentRowsLoaded = currentRowsLoaded;
        sessionStorage.setItem(`${collectionHandle}-rowsLoaded`, currentRowsLoaded);

        // Place promos now that rows count is increased (desktop or mobile)
        if (window.innerWidth < 992) {
          displayPromoImages('data-mob-row');
        } else {
          displayPromoImages('data-desk-row');
        }

        // pagination update
        const nextPaginationLink = doc.querySelector('.coll-more-scroll .load-more');
        if (nextPaginationLink) {
          const newHref = nextPaginationLink.getAttribute('href');
          loadMoreBtn.setAttribute('href', newHref);
          sessionStorage.setItem(`${collectionHandle}-loadMoreHref`, newHref);
        } else {
          if (collMoreEl) collMoreEl.remove();
          sessionStorage.removeItem(`${collectionHandle}-loadMoreHref`);
        }

        if (collMoreEl) collMoreEl.classList.remove('loading');

        if (typeof quick_buy_btn === 'function') quick_buy_btn();

        // rebind events on newly added products
        attachProductClickEvents();
      })
      .catch(err => {
        console.error('Error loading products:', err);
      })
      .finally(() => {
        isLoading = false;
      });
  };

  // observe load-more button for intersection
  const observeLoadMoreBtn = () => {
    if (!loadMoreBtn) return;
    const observerOptions = { root: null, threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading) {
          loadNextPage();
        }
      });
    }, observerOptions);
    observer.observe(loadMoreBtn);
  };

  observeLoadMoreBtn();
}

/* ---------- click/save logic (unchanged, but relies on normalized IDs) ---------- */

function attachProductClickEvents() {
  const productLinks = document.querySelectorAll('.product-item a');
  productLinks.forEach(link => {
    // remove existing named handler (works because handleProductClick is a named fn)
    link.removeEventListener('click', handleProductClick);
    link.addEventListener('click', handleProductClick);
  });
}

function handleProductClick() {
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const productGrid = document.querySelector('#product-grid');
  const loadMoreBtn = document.querySelector('.load-more');

  sessionStorage.setItem(`${collectionHandle}-scrollPos`, window.scrollY);
  sessionStorage.setItem(`${collectionHandle}-gridHTML`, productGrid.innerHTML);
  if (loadMoreBtn) sessionStorage.setItem(`${collectionHandle}-loadMoreHref`, loadMoreBtn.getAttribute('href'));
  sessionStorage.setItem(`${collectionHandle}-rowsLoaded`, currentRowsLoaded);
}

/* ---------- restore on DOMContentLoaded (normalize restored HTML) ---------- */

document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.querySelector('#product-grid');
  const loadMoreBtn = document.querySelector('.load-more');
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const savedScrollPos = sessionStorage.getItem(`${collectionHandle}-scrollPos`);
  const savedGridHTML = sessionStorage.getItem(`${collectionHandle}-gridHTML`);
  const savedLoadMoreHref = sessionStorage.getItem(`${collectionHandle}-loadMoreHref`);
  const savedRowsLoaded = sessionStorage.getItem(`${collectionHandle}-rowsLoaded`);

  if (savedGridHTML && savedScrollPos) {
    productGrid.innerHTML = savedGridHTML;

    // IMPORTANT: normalize restored elements (gives them data-id/data-promo-id)
    normalizeExistingIds(productGrid);

    if (savedLoadMoreHref && loadMoreBtn) {
      loadMoreBtn.setAttribute('href', savedLoadMoreHref);
    }
    if (savedRowsLoaded) {
      currentRowsLoaded = parseInt(savedRowsLoaded, 10);
    }
    window.scrollTo(0, parseInt(savedScrollPos, 10));

    // cleanup stored keys
    sessionStorage.removeItem(`${collectionHandle}-scrollPos`);
    sessionStorage.removeItem(`${collectionHandle}-gridHTML`);
    sessionStorage.removeItem(`${collectionHandle}-loadMoreHref`);
    sessionStorage.removeItem(`${collectionHandle}-rowsLoaded`);
  }

  // init click handlers
  attachProductClickEvents();
});

/* ---------- rest of your DOMContentLoaded logic (unchanged) ---------- */

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('.coll-desc')) {
    const descWrapper = document.querySelector(".coll-desc-wrapper");
    const shortDesc = descWrapper.querySelector(".coll-short-desc");
    const readMoreBtn = descWrapper.querySelector(".coll-desc-read");
    function checkDescription() {
      const shortDescHeight = shortDesc.offsetHeight;
      shortDesc.style.webkitLineClamp = "unset";
      const fullDescHeight = shortDesc.offsetHeight;
      shortDesc.style.webkitLineClamp = "2";
      if (fullDescHeight <= shortDescHeight) {
        readMoreBtn.style.display = "none";
      } else {
        readMoreBtn.style.display = "inline-block";
      }
      document.querySelector('.coll-desc').style.maxHeight = document.querySelector('.coll-desc .coll-desc-wrapper').clientHeight + 'px';
    }
    window.addEventListener("resize", checkDescription);
    checkDescription();
  }
});

document.addEventListener("DOMContentLoaded", (event) => {
  load_more();

  if (document.querySelector('.coll-desc-read')) {
    document.querySelector('.coll-desc-read').addEventListener('click', function(e){
      e.preventDefault();
      document.querySelector('.coll-desc').classList.toggle('active-full-desc');
      if (document.querySelector('.coll-desc.active-full-desc')) {
        document.querySelector('.coll-desc.active-full-desc').style.maxHeight = '';
      }
    });
  }

  if (localStorage.getItem("collection_grid") == null) {
    localStorage.setItem("collection_grid", document.querySelector(".coll-view a.active").getAttribute('data-view'));
  } else {
    document.querySelector(".collection-grid").setAttribute('data-desk', localStorage.getItem("collection_grid"));
    if (document.querySelector(".coll-view a.active").getAttribute('data-view') != localStorage.getItem("collection_grid")) {
      document.querySelector(".coll-view a.active").classList.remove('active');
      let deskGrids = document.querySelectorAll(".coll-view a");
      deskGrids.forEach((deskGrid) => {
        let desk_val = deskGrid.getAttribute('data-view');
        if (parseInt(desk_val) == parseInt(localStorage.getItem("collection_grid"))) {
          deskGrid.classList.add('active');
        }
      });
    }
  }

  if (document.querySelectorAll('.coll-view a')) {
    document.querySelectorAll('.coll-view a').forEach((grid) => {
      grid.addEventListener('click', function(e){
        e.preventDefault();
        localStorage.setItem("collection_grid", grid.getAttribute('data-view'));
        document.querySelector(".collection-grid").setAttribute('data-desk', localStorage.getItem("collection_grid"));
        const desk_grids = document.querySelectorAll(".coll-view a.active");
        desk_grids.forEach((desk_grid) => {
          desk_grid.classList.remove("active");
        });
        grid.classList.add("active");
        resize_promo();
      });
    });
  }

  if (document.querySelector('.coll-title')) {
    document.querySelector('.coll-title').addEventListener('click', function(e){
      e.preventDefault();
      if (document.body.classList.contains('sticky-filter')) {
        document.body.classList.toggle('open-subcoll');
        document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search','open-filter');
      }
    });
  }
  resize_promo();
});

window.addEventListener("resize", resize_promo);

window.addEventListener('scroll', (e) => {
  if (document.querySelector('.coll-desc')) {
    let scrollDistance = window.pageYOffset;
    if (scrollDistance > 0) {
      document.querySelector('.coll-desc').style.maxHeight = '0px';
      document.querySelector('.coll-desc').classList.add('scroll-start');
    } else {
      document.querySelector('.coll-desc').style.maxHeight = document.querySelector('.coll-desc .coll-desc-wrapper').clientHeight + 'px';
      document.querySelector('.coll-desc').classList.remove('scroll-start');
    }
  }
});

// Clear only collection-related sessionStorage keys when navigating to a new collection
document.querySelectorAll('.menu-drawer-wrapper a').forEach(anchor => {
  anchor.addEventListener('click', function() {
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes('-scrollPos') || key.includes('-gridHTML') || key.includes('-loadMoreHref') || key.includes('-rowsLoaded')) {
        sessionStorage.removeItem(key);
      }
    });
  });
});

}else{
function load_more(){
  const loadMoreBtn = document.querySelector('.load-more');
  let currentRowsLoaded = window.restoredRowsLoaded || 2;
  let isLoading = false;
  const desktopProductsPerRow = parseInt(document.querySelector('.collection-grid').getAttribute('data-desk'));
  const mobileProductsPerRow = 2;
  const rowsPerLoad = 2;
  const desktopPromoImages = document.querySelectorAll('.snippet-promo-image.desk-promo');
  const mobilePromoImages = document.querySelectorAll('.snippet-promo-image.mb-promo');
  const isMobile = window.innerWidth < 992;
  const getProductsPerRow = () => (isMobile ? mobileProductsPerRow : desktopProductsPerRow);
  const productGrid = document.querySelector('#product-grid');
  
  // Function to get collection identifier
  const getCollectionId = () => {
    return document.body.getAttribute('data-collection-handle') || window.location.pathname;
  };
  
  const loadNextPage = () => {
    if (!loadMoreBtn || isLoading) return;
    const nextPageUrl = loadMoreBtn.getAttribute('href');
    if (!nextPageUrl) return;
    isLoading = true;
    if (document.querySelector('.coll-more-scroll')) {
      document.querySelector('.coll-more-scroll').classList.add('loading');
    }
    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        document.querySelectorAll('.blank-span').forEach(blankDiv => {
          blankDiv.remove();
        });
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelectorAll('.collection-grid .product-item');
        const newPromos = doc.querySelectorAll('.snippet-promo-image');
        const nextPaginationLink = doc.querySelector('.coll-more-scroll .load-more');
        
        newProducts.forEach(product => {
          const productId = product.getAttribute('data-id');
          if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
            productGrid.appendChild(product);
          }
        });
        
        // Add new promo images from the loaded page
        newPromos.forEach(promo => {
          const promoId = promo.getAttribute('data-promo-id') || Math.random().toString(36).substring(7);
          promo.setAttribute('data-promo-id', promoId);
          if (!document.querySelector(`[data-promo-id="${promoId}"]`)) {
            productGrid.appendChild(promo);
          }
        });
        
        let parentElement = document.querySelector('.collection-grid');
        for(let i = 0; i < parseInt(document.querySelector('.collection-grid').getAttribute('data-limit')); i++){
          let span = document.createElement("span");
          span.classList.add("blank-span");
          parentElement.appendChild(span);
        }

        let allProducts = document.getElementById('product-grid').querySelectorAll('.product-item').length;
        let checkHowManyRowsLoaded = allProducts / 4;
        
        const displayPromoImages = (promoImages, rowAttribute) => {
          promoImages.forEach(promo => {
            const promoRow = parseInt(promo.getAttribute(rowAttribute), 10);
            const productsPerRow = getProductsPerRow();
            const productsLoaded = currentRowsLoaded * productsPerRow;

            if (promoRow <= checkHowManyRowsLoaded + rowsPerLoad && promo.style.display === 'none') {
              promo.style.display = 'block';
              productGrid.appendChild(promo);
            }
          });
        };
        
        if (isMobile) {
          displayPromoImages(mobilePromoImages, 'data-mob-row');
        } else {
          displayPromoImages(desktopPromoImages, 'data-desk-row');
        }
        
        currentRowsLoaded += rowsPerLoad;
        
        // Save the updated state after loading new products
        window.currentRowsLoaded = currentRowsLoaded;
        const collectionId = getCollectionId();
        sessionStorage.setItem(`${collectionId}-currentRowsLoaded`, currentRowsLoaded);
        
        // Save promo images state
        savePromoImagesState();
        
        if (nextPaginationLink) {
          const newHref = nextPaginationLink.getAttribute('href');
          loadMoreBtn.setAttribute('href', newHref);
          sessionStorage.setItem(`${collectionId}-loadMoreHref`, newHref);
        } else {
          if (document.querySelector('.coll-more-scroll')) {
            document.querySelector('.coll-more-scroll').remove();
          }
          sessionStorage.removeItem(`${collectionId}-loadMoreHref`);
        }
        
        if (document.querySelector('.coll-more-scroll')) {
          document.querySelector('.coll-more-scroll').classList.remove('loading');
        }
        if (typeof quick_buy_btn === 'function') {
          quick_buy_btn();
        }
      })
      .catch(err => console.error('Error loading products:', err))
      .finally(() => {
        isLoading = false;
      });
  };
  
  const observeLoadMoreBtn = () => {
    if (!loadMoreBtn) return;
    // Check if the button has a valid href before observing
    const currentHref = loadMoreBtn.getAttribute('href');
    if (!currentHref || currentHref === '' || currentHref === '#') return;
    
    const observerOptions = {
      root: null,
      threshold: 0.5,
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading) {
          loadNextPage();
        }
      });
    }, observerOptions);
    observer.observe(loadMoreBtn);
  };
  
  observeLoadMoreBtn();
}

// Function to save promo images state
function savePromoImagesState() {
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const promoImages = document.querySelectorAll('.snippet-promo-image');
  const promoState = [];
  
  promoImages.forEach(promo => {
    promoState.push({
      id: promo.getAttribute('data-promo-id') || Math.random().toString(36).substring(7),
      html: promo.outerHTML,
      display: promo.style.display,
      dataDeskRow: promo.getAttribute('data-desk-row'),
      dataMobRow: promo.getAttribute('data-mob-row'),
      classList: promo.className
    });
  });
  
  sessionStorage.setItem(`${collectionHandle}-promoState`, JSON.stringify(promoState));
}

// Function to restore promo images state
function restorePromoImagesState() {
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const savedPromoState = sessionStorage.getItem(`${collectionHandle}-promoState`);
  const productGrid = document.querySelector('#product-grid');
  
  if (savedPromoState) {
    const promoState = JSON.parse(savedPromoState);
    
    // Remove existing promo images
    document.querySelectorAll('.snippet-promo-image').forEach(promo => promo.remove());
    
    // Add saved promo images
    promoState.forEach(promo => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = promo.html;
      const promoElement = tempDiv.firstElementChild;
      
      // Restore attributes and styles
      if (promo.dataDeskRow) promoElement.setAttribute('data-desk-row', promo.dataDeskRow);
      if (promo.dataMobRow) promoElement.setAttribute('data-mob-row', promo.dataMobRow);
      promoElement.className = promo.classList;
      promoElement.style.display = promo.display;
      promoElement.setAttribute('data-promo-id', promo.id);
      
      productGrid.appendChild(promoElement);
    });
    
    // Clean up session storage
    sessionStorage.removeItem(`${collectionHandle}-promoState`);
  }
}

function attachClickEvent() {
  document.querySelectorAll('.load-more a').forEach(anchor => {
    anchor.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    });
  });

  // Save scroll position and loaded products before navigating to the product page
  document.querySelectorAll('#product-grid a').forEach(anchor => {
    anchor.addEventListener('click', function() {
      sessionStorage.setItem('scrollPosition', window.scrollY);
      saveLoadedProducts();
    });
  });
}

// Enhanced save function to include pagination state and promo images
function saveLoadedProducts() {
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const loadedProducts = document.querySelector("#product-grid").innerHTML;
  const loadMoreBtn = document.querySelector('.load-more');
  
  sessionStorage.setItem(`${collectionHandle}-loadedProducts`, loadedProducts);
  sessionStorage.setItem(`${collectionHandle}-scrollPosition`, window.scrollY);
  sessionStorage.setItem(`${collectionHandle}-collectionURL`, window.location.href);
  
  // Save the current pagination state
  if (loadMoreBtn) {
    sessionStorage.setItem(`${collectionHandle}-loadMoreHref`, loadMoreBtn.getAttribute('href'));
  }
  
  // Save current rows loaded (this is the key fix)
  if (typeof window.currentRowsLoaded !== 'undefined') {
    sessionStorage.setItem(`${collectionHandle}-currentRowsLoaded`, window.currentRowsLoaded);
  }
  
  // Save promo images state
  savePromoImagesState();
}

document.addEventListener('DOMContentLoaded', () => {
  const productLinks = document.querySelectorAll('.product-item a');
  const productGrid = document.querySelector('#product-grid');
  const loadMoreBtn = document.querySelector('.load-more');
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  
  productLinks.forEach(link => {
    link.addEventListener('click', () => {
      sessionStorage.setItem(`${collectionHandle}-scrollPos`, window.scrollY);
      sessionStorage.setItem(`${collectionHandle}-gridHTML`, productGrid.innerHTML);
      if(loadMoreBtn) sessionStorage.setItem(`${collectionHandle}-loadMoreHref`, loadMoreBtn.getAttribute('href'));
      // Save the current rows loaded state
      sessionStorage.setItem(`${collectionHandle}-currentRowsLoaded`, window.currentRowsLoaded || 2);
      
      // Save promo images state
      savePromoImagesState();
    });
  });
});

// Consolidated restore function - runs once on page load
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/collections')) {
    const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
    const productGrid = document.querySelector('#product-grid');
    const loadMoreBtn = document.querySelector('.load-more');
    
    // Try both key patterns for backward compatibility
    const savedScrollPos = sessionStorage.getItem(`${collectionHandle}-scrollPos`) || sessionStorage.getItem(`${collectionHandle}-scrollPosition`);
    const savedGridHTML = sessionStorage.getItem(`${collectionHandle}-gridHTML`) || sessionStorage.getItem(`${collectionHandle}-loadedProducts`);
    const savedLoadMoreHref = sessionStorage.getItem(`${collectionHandle}-loadMoreHref`);
    const savedCurrentRowsLoaded = sessionStorage.getItem(`${collectionHandle}-currentRowsLoaded`);
    const savedCollectionURL = sessionStorage.getItem(`${collectionHandle}-collectionURL`);
    
    // Only restore if we have saved state and we're on the same URL (or no URL check needed for backward compat)
    const shouldRestore = savedGridHTML && (!savedCollectionURL || savedCollectionURL === window.location.href);
    
    if (shouldRestore) {
      productGrid.innerHTML = savedGridHTML;
      
      // Restore the load more button state ONLY if we have a valid href
      if (savedLoadMoreHref && loadMoreBtn) {
        loadMoreBtn.setAttribute('href', savedLoadMoreHref);
      } else if (loadMoreBtn && !savedLoadMoreHref) {
        // If there's no saved href, we were on the last page - remove the button to prevent duplicate loading
        const collMoreEl = document.querySelector('.coll-more-scroll');
        if (collMoreEl) collMoreEl.remove();
      }
      
      // Restore the currentRowsLoaded state
      if (savedCurrentRowsLoaded) {
        window.restoredRowsLoaded = parseInt(savedCurrentRowsLoaded, 10);
      }
      
      // Restore promo images state
      restorePromoImagesState();
      document.querySelectorAll('.variant-grid').forEach(function(sizeList){
        sizeList.dataset.quickaddInitialized = '';
      });
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      
      // Restore scroll position
      if (savedScrollPos) {
        window.scrollTo(0, parseInt(savedScrollPos, 10));
      }
      
      // Clean up ALL session storage keys for this collection
      sessionStorage.removeItem(`${collectionHandle}-scrollPos`);
      sessionStorage.removeItem(`${collectionHandle}-scrollPosition`);
      sessionStorage.removeItem(`${collectionHandle}-gridHTML`);
      sessionStorage.removeItem(`${collectionHandle}-loadedProducts`);
      sessionStorage.removeItem(`${collectionHandle}-loadMoreHref`);
      sessionStorage.removeItem(`${collectionHandle}-currentRowsLoaded`);
      sessionStorage.removeItem(`${collectionHandle}-collectionURL`);
    }
    
    attachClickEvent();
  }
});

// Save state when clicking on a product link
document.addEventListener('click', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

// Save scroll position before the user leaves the page
window.addEventListener('beforeunload', function() {
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  sessionStorage.setItem(`${collectionHandle}-scrollPosition`, window.scrollY);
});

// Clear only collection-related sessionStorage keys when navigating to a new collection
document.querySelectorAll('.menu-drawer-wrapper a').forEach(anchor => {
  anchor.addEventListener('click', function() {
    // Loop through sessionStorage keys and remove only collection-related ones
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes('collection') || key.includes('scrollPosition') || key.includes('gridHTML') || key.includes('loadMoreHref') || key.includes('rowsLoaded') || key.includes('loadedProducts') || key.includes('collectionURL') || key.includes('currentRowsLoaded') || key.includes('promoState')) {
        sessionStorage.removeItem(key);
      }
    });
  });
});

// Restore scroll position when the page is shown (including back navigation)
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
    const scrollPosition = sessionStorage.getItem(`${collectionHandle}-scrollPosition`);
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition, 10));
      sessionStorage.removeItem(`${collectionHandle}-scrollPosition`);
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelector('.coll-desc')){
    const descWrapper = document.querySelector(".coll-desc-wrapper");
    const shortDesc = descWrapper.querySelector(".coll-short-desc");
    const longDesc = descWrapper.querySelector(".coll-long-desc");
    const readMoreBtn = descWrapper.querySelector(".coll-desc-read");
    function checkDescription() {
      const shortDescHeight = shortDesc.offsetHeight;
      shortDesc.style.webkitLineClamp = "unset";
      const fullDescHeight = shortDesc.offsetHeight;
      shortDesc.style.webkitLineClamp = "2";
      if (fullDescHeight <= shortDescHeight) {
        readMoreBtn.style.display = "none";
      } else {
        readMoreBtn.style.display = "inline-block";
      }
      document.querySelector('.coll-desc').style.maxHeight = document.querySelector('.coll-desc .coll-desc-wrapper').clientHeight+'px';
    }
    window.addEventListener("resize", checkDescription);
    checkDescription();
  }
});

document.addEventListener("DOMContentLoaded", (event) => {
  // Initialize load_more and restore state if needed
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const savedCurrentRowsLoaded = sessionStorage.getItem(`${collectionHandle}-currentRowsLoaded`);
  
  // If we have saved state, we need to modify the load_more function to use it
  if (savedCurrentRowsLoaded && window.savedRowsLoaded) {
    // We'll handle this in the load_more function initialization
  }
  
  load_more();
  
  if(document.querySelector('.coll-desc-read')) document.querySelector('.coll-desc-read').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.coll-desc').classList.toggle('active-full-desc');
    if(document.querySelector('.coll-desc.active-full-desc')){
      document.querySelector('.coll-desc.active-full-desc').style.maxHeight = '';
    }
  });
  
  if(localStorage.getItem("collection_grid") == null){
    localStorage.setItem("collection_grid", document.querySelector(".coll-view a.active").getAttribute('data-view'));
  }else{
    document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
    if(document.querySelector(".coll-view a.active").getAttribute('data-view') != localStorage.getItem("collection_grid")){
      document.querySelector(".coll-view a.active").classList.remove('active')
      let deskGrids = document.querySelectorAll(".coll-view a");
      deskGrids.forEach((deskGrid) => {
        let desk_val = deskGrid.getAttribute('data-view')
        if(parseInt(desk_val) == parseInt(localStorage.getItem("collection_grid"))){
          deskGrid.classList.add('active')
        }
      });
    }
  }
  
  if(document.querySelectorAll('.coll-view a')) document.querySelectorAll('.coll-view a').forEach((grid) => {
    grid.addEventListener('click',function(e){
      e.preventDefault();
      localStorage.setItem("collection_grid", grid.getAttribute('data-view'));
      document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
      const desk_grids = document.querySelectorAll(".coll-view a.active");
      desk_grids.forEach((desk_grid) => {
        desk_grid.classList.remove("active");
      });
      grid.classList.add("active");
      resize_promo();
    });
  });
  
  if(document.querySelector('.coll-title')) document.querySelector('.coll-title').addEventListener('click',function(e){
    e.preventDefault();
    if(document.body.classList.contains('sticky-filter')){
      document.body.classList.toggle('open-subcoll');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search','open-filter');
    }
  })
  resize_promo();
});

window.addEventListener("resize", resize_promo);
window.addEventListener('scroll', (e)=> {
  if(document.querySelector('.coll-desc')){
    let scrollDistance = window.pageYOffset
    if(scrollDistance > 0){
      document.querySelector('.coll-desc').style.maxHeight = '0px'
      document.querySelector('.coll-desc').classList.add('scroll-start')
    }else{
      document.querySelector('.coll-desc').style.maxHeight = document.querySelector('.coll-desc .coll-desc-wrapper').clientHeight+'px'
      document.querySelector('.coll-desc').classList.remove('scroll-start')
    }
  }
})
}